/**
 * @generated SignedSource<<4fe0ab79419cc50dd5b23b7724ea75ba>>
 * @relayHash c04d7f2f39419bac7cfc3ba24d416e48
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID ac32b88da303fbdd882aa63a9a680e9498c5a1ca5e27e1eb5c6dcd624ef6ef4d

import type { ConcreteRequest } from 'relay-runtime';
export type HomeRecentRovoActivationQuery$variables = {
  cloudId: string;
};
export type HomeRecentRovoActivationQuery$data = {
  readonly tenantContexts: ReadonlyArray<{
    readonly activationIdByProduct: {
      readonly active: string | null;
    } | null;
  } | null> | null;
};
export type HomeRecentRovoActivationQuery = {
  response: HomeRecentRovoActivationQuery$data;
  variables: HomeRecentRovoActivationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  }
],
v1 = [
  {
    "args": [
      {
        "items": [
          {
            "kind": "Variable",
            "name": "cloudIds.0",
            "variableName": "cloudId"
          }
        ],
        "kind": "ListValue",
        "name": "cloudIds"
      }
    ],
    "concreteType": "TenantContext",
    "kind": "LinkedField",
    "name": "tenantContexts",
    "plural": true,
    "selections": [
      {
        "args": [
          {
            "kind": "Literal",
            "name": "product",
            "value": "rovo"
          }
        ],
        "concreteType": "TenantContextActivationId",
        "kind": "LinkedField",
        "name": "activationIdByProduct",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "active"
          }
        ],
        "storageKey": "activationIdByProduct(product:\"rovo\")"
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "HomeRecentRovoActivationQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "HomeRecentRovoActivationQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "c04d7f2f39419bac7cfc3ba24d416e48",
    "id": "ac32b88da303fbdd882aa63a9a680e9498c5a1ca5e27e1eb5c6dcd624ef6ef4d",
    "metadata": {},
    "name": "HomeRecentRovoActivationQuery",
    "operationKind": "query",
    "text": "query HomeRecentRovoActivationQuery($cloudId:ID!){tenantContexts(cloudIds:[$cloudId]){activationIdByProduct(product:\"rovo\"){active}}}"
  }
};
})();

(node as any).hash = "4a23e7f8c2b00f4c9bc7da80369430fb";

export default node;
